__turbopack_context__.v({
  "lowQuestionnaireUsagePercentage": "LowQuestionnaireUsagePercentage-module__tohb8a__lowQuestionnaireUsagePercentage",
});
